/* 🤖 this file was generated by svg-to-ts */
export const matIconCallToAction: {
  name: 'call-to-action';
  data: string;
} = {
  name: 'call-to-action',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 15h14v3H5z"/></svg>`
};
